import { LitElement, css, html, nothing } from 'lit';
import { customElement, property} from 'lit/decorators.js'
import { AnnouncementType, services } from 'src/services';
import { consume } from '@lit/context';
import { editModeContext } from 'src/context/content-context';
import { Task } from '@lit/task';

@customElement('ctx-announcements')
export class Announcements extends LitElement {

  static styles = css`
    :host {
      display:contents;
    }

    .announcement-preview {
      background-color: var(--card-background-color);
      padding: 10px;
    }
  `

  @consume({ context: editModeContext }) 
  editMode: boolean = false;

  @property({ type: Number, attribute: "filter-id" })
  filterId?: number;

  @property({ type: String })
  filter?: string;

  connectedCallback() {
    super.connectedCallback();

    if(!this.editMode){
      this._apiTask.run();
    } 
  }

    private _apiTask = new Task(this,
      {
        task: async () => {
          return await services.announcements.getAnnouncements(this.filterId, this.filter);
        },
        autoRun: false
      },
    );

  renderAnnouncements = (announcements: AnnouncementType[]) => {
    if(announcements.length === 0) {
      return nothing;
    }
    return html`
        <slot></slot>
        ${announcements.map(a => html`<markdown-content data-announcement-name=${a.name} .htmlContent=${a.htmlContent}></markdown-content>`)}`
  }

  render() {
    if(this.editMode){
      return html`<slot></slot><div class="announcement-preview">Announcements ${this.filter ? `that have the tag "${this.filter}"` : ""} will be shown here when published.</div>`
    }

    return html`
      ${this._apiTask.render({
      pending: () => nothing,
      complete: (announcements) => this.renderAnnouncements(announcements),
      error: () => nothing
    })}`;
  }
}
